<template>
  <div v-if="authenticated" class="logged-in-box">
    <div class="logged-company-name">
      <a href="/ostajille" class="button header-pyyda-tarjous logged-in-btn"><i class="fa-sharp fa-solid fa-user"></i> <span>{{ profile.first_name }}</span></a>
    </div>
  </div>
</template>
<script setup>
import { storeToRefs } from 'pinia'
import { useBuyerStore } from '@stores/BuyerStore'

const buyerStore = useBuyerStore()
const { profile, authenticated } = storeToRefs(buyerStore)

</script>